import React, { useContext, useState, useEffect } from "react";
import styled from "styled-components";

import PlayerManager from "../../../service/player-manager";
import SocketService from "../../../service/socket";
import UIManager from "../../../service/ui-manager";
import { PlayerStateContext } from "../../../provider";
import { Row, Col, Text, Box } from "../../../comps";
import { Theme } from "../../../theme/theme-provider";

const Wrapper = styled(Col)`
  position: relative;
  width: 100%;
  height: 100%;
  opacity: ${({ hovered }) => (hovered ? 1 : 0)};
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 0, 0, 0.7) 10%,
    rgba(0, 0, 0, 0) 20%,
    rgba(0, 0, 0, 0) 100%
  );
  cursor: ${({ hovered }) => (hovered ? "default" : "none")};
`;

const Head = styled(Row)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 20%;
  padding-left: 3%;
  padding-right: 2%;
  align-items: center;
  justify-content: space-between;
`;

const ClickBg = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export default () => {
  const DBL_CLICK_TIME = 300,
    CLICK_RESPONSE_TIME = 350;
  const [playerState] = useContext(PlayerStateContext);
  const { title, isPlaying } = playerState;
  const [hoverInfo, setHoverInfo] = useState({
    hover: false,
    time: 0,
    funId: "",
  });
  const { hover, time, funId } = hoverInfo;
  const [click, setClick] = useState({ clickTime: 0, clickTimerId: "" });
  const { clickTime, clickTimerId } = click;

  const togglePlay = () => {
    if (isPlaying) {
      PlayerManager.pause();
      SocketService.pause();
    } else {
      PlayerManager.resume();
      SocketService.resume();
    }
  };

  const handleEnterFullScreen = () => {
    UIManager.enterFullScreenMode();
  };

  useEffect(() => {
    clearTimeout(funId);
    const id = setTimeout(() => {
      setHoverInfo({ hover: false, time });
    }, 2000);
    setHoverInfo({ hover, time, funId: id });
  }, [time]);

  const onMouseMove = () => {
    setHoverInfo({ hover: true, time: new Date().getTime(), funId });
  };

  const onClick = () => {
    clearTimeout(clickTimerId);
    const diff = new Date().getTime() - clickTime;
    if (diff <= DBL_CLICK_TIME) {
      handleEnterFullScreen();
    } else {
      const newClickTimerId = setTimeout(() => {
        togglePlay();
      }, CLICK_RESPONSE_TIME);
      setClick({
        clickTime: new Date().getTime(),
        clickTimerId: newClickTimerId,
      });
    }
  };

  return (
    <Wrapper hovered={hover} onMouseMove={onMouseMove} onD>
      <ClickBg onClick={onClick} />
      <Head>
        <Text
          fontSize="18px"
          color={Theme.color.GRAY_0}
          fontWeight={600}
          oneline={true}
        >
          {title}
        </Text>
      </Head>
    </Wrapper>
  );
};
